export default {
  "content": "<g clip-path=\"url(#icon_chevron_up_down_outlined_svg__a)\"><path d=\"M10.99 4a.47.47 0 01-.35-.15L8 1.21 5.35 3.85c-.2.2-.51.2-.71 0-.2-.2-.2-.51 0-.71l3-2.99c.2-.2.51-.2.71 0l3 3c.2.2.2.51 0 .71-.1.1-.23.15-.35.15L10.99 4zm0 8a.47.47 0 00-.35.15L8 14.79l-2.64-2.64c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l3 3c.2.2.51.2.71 0l3-3c.2-.2.2-.51 0-.71-.1-.1-.23-.15-.35-.15h-.02z\"/></g><defs><clipPath id=\"icon_chevron_up_down_outlined_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};